import { MantineProvider } from "@mantine/core";
import { ModalsProvider } from "@mantine/modals";
import { Notifications } from "@mantine/notifications";
import { QueryClientProvider } from "@tanstack/react-query";

import type { ReactNode } from "react";

import { queryClient } from "@/lib/query-client";
import { installToastGestures } from "@/lib/toast-gestures";
import { mantineTheme } from "@/theme/mantine-theme";

// トーストを本体クリック / 右スワイプで閉じられるように notifications.show をラップする（1 回だけ）。
installToastGestures();

interface AppProvidersProps {
  children: ReactNode;
}

export function AppProviders({ children }: AppProvidersProps) {
  return (
    <QueryClientProvider client={queryClient}>
      <MantineProvider theme={mantineTheme} defaultColorScheme="light">
        <ModalsProvider>
          {/* containerWidth: 既定 440px はエラー文など長めのメッセージが窮屈に折り返すため、
              余裕を持って収まる既定幅にする（100% を超えないので狭い画面では自動でクランプ）。 */}
          <Notifications
            position="top-right"
            autoClose={4000}
            limit={5}
            containerWidth={480}
          />
          {children}
        </ModalsProvider>
      </MantineProvider>
    </QueryClientProvider>
  );
}
